// https://gist.github.com/jed/982883

import { isFunction } from './typeguards.js';

/**
 * Generates a random number either using the window.crypto.getRandomValues method (if available)
 * or using the Math.random method.
 *
 * @param {number} max The maximum number to generate (exclusive).
 * @returns {number} A random number between 0 (inclusive) and max (exclusive).
 */
const randomNumber = (max: number): number => {
    if (isFunction(window.crypto?.getRandomValues)) {
        return window.crypto.getRandomValues(new Uint8Array(1))[0] % max;
    } else {
        return Math.random() * max;
    }
}

/**
 * Generates a UUID (Universally Unique Identifier) as a string.
 *
 * @returns {string} A UUID in the format of "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".
 */
const _generateUUID = (): string => '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, n => (+n ^ randomNumber(16) >> +n / 4).toString(16));

/**
 * Generates a UUID (Universally Unique Identifier) as a string.
 * Uses the native window.crypto.randomUUID method if available, otherwise falls back to a custom implementation.
 *
 * @returns {string} A UUID in the format of "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".
 */
export const generateUUID = (): string => isFunction(window.crypto?.randomUUID) ? window.crypto.randomUUID() : _generateUUID();
